import { useFacility, useProfile } from '@hook'
import type { FacilityReportBranding, ResultDocumentBranding } from '@type/facility.type'
import { useProfile as useProfileStore } from '@zustore/store'
import { useMemo } from 'react'
import { resolveReportLayouts } from './resolveReportLayouts'

/**
 * Layouts for live report/template UIs.
 * Prefers document snapshot, then template branding, then facility, then defaults.
 */
export function useFacilityReportBranding(
  documentBranding?: Partial<FacilityReportBranding> | ResultDocumentBranding | null,
  templateBranding?: Partial<FacilityReportBranding> | null
) {
  const { facilityId } = useProfile({ isLoggedIn: true })
  const { facility: storedFacility } = useProfileStore()
  const { singleFacility } = useFacility({ id: facilityId })

  return useMemo(
    () =>
      resolveReportLayouts({
        documentBranding,
        templateBranding,
        facilityBranding: singleFacility?.attributes?.report_branding ?? storedFacility?.report_branding
      }),
    [documentBranding, templateBranding, singleFacility?.attributes?.report_branding, storedFacility?.report_branding]
  )
}
